import Header from './components/Header';
import Hero from './components/Hero';
import Ranking from './components/Ranking';
import Cards from './components/Cards';
import Comments from './components/Comments';
import Media from './components/Media';
import About from './components/About';
import Topics from './components/Topics';
import Carousel from './components/Carousel';
import Index from './components/Index';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import App from './components/App';
import Updates from './components/Updates';
import Features from './components/Features';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Ranking />
        <Cards />
        <Comments />
        <Media />
        <About />
        <Topics />
        <Carousel />
        <Index />
        <FAQ />
        <Contact />
        <App />
        <Updates />
        <Features />
      </main>
      <Footer />
    </>
  );
}